import { useTranslation } from 'react-i18next';
import { InfluencerFeedPost, InfluencerNewProfileHeaderV2 } from '@anytag/graphql';
import { MediaPreviewWithMetrics } from '@anytag/shared-atoms';
import { THEME } from '@anytag/shared-constants';
import { usePostDetailsParam } from '@anytag/shared-hooks';
import { ImageSlider, InfluencerPostDetailsModal } from '@anytag/shared-molecules';
import { bigIntFormatter } from '@anytag/shared-utils';
import { useInfluencerProfileOpacityContent } from '../../../hooks';
import { InfluencerSelectedAccountInfo } from '../../../types';
import { InfluencerProfileFeedPostsWrapper } from '../../shared';

const FEED_PARAMS_KEY = 'feedPopup';

interface InfluencerFacebookProfileFeedPostsProps {
  data?: readonly InfluencerFeedPost[];
  socialAccount: InfluencerSelectedAccountInfo;
  influencerProfile: InfluencerNewProfileHeaderV2;
}

export const InfluencerFacebookProfileFeedPosts = ({
  data = [],
  socialAccount,
  influencerProfile: { id: influencerId, name }
}: InfluencerFacebookProfileFeedPostsProps) => {
  const { t } = useTranslation();
  const { setPostDetailsParam } = usePostDetailsParam(FEED_PARAMS_KEY);
  const { opacityContent } = useInfluencerProfileOpacityContent({
    influencerId,
    socialAccount,
    skipEstimateContent: true
  });

  return (
    <>
      <InfluencerProfileFeedPostsWrapper
        dataNotAvailable={!data.length}
        title={t('HeaderColumn.Feed Posts')}
        moreDetailProps={{
          to: '/influencer/$id/$socialMediaAccountId/scraping_feed_posts',
          params: { socialMediaAccountId: socialAccount.id.toString() },
          search: { filter: { name, type: socialAccount.type } }
        }}
        {...opacityContent}
      >
        <ImageSlider total={data.length} css={{ paddingLeft: '16px' }}>
          {data.map(({ id, thumbnail, caption, reactions, comments }) => (
            <MediaPreviewWithMetrics
              key={id}
              src={thumbnail}
              caption={caption}
              css={THEME.mediaPreview.default}
              onClick={() => setPostDetailsParam(id)}
              captionProps={THEME.mediaPreview.feedPostCaptionDims}
              statistics={[
                { label: t('General.Reactions'), value: bigIntFormatter(reactions, 0, { k: true, m: true }) },
                { label: t('General.Comments'), value: bigIntFormatter(comments, 0, { k: true, m: true }) }
              ]}
              showIcon
            />
          ))}
        </ImageSlider>
      </InfluencerProfileFeedPostsWrapper>

      <InfluencerPostDetailsModal paramKey={FEED_PARAMS_KEY} posts={data.map(({ id }) => ({ id, influencerId }))} />
    </>
  );
};
